var cov_vvh503vkb = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Breadcrumb/styles/index.ts",
      hash = "6bd1e52e3859989cc303de19ed476227f9a711bd",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Breadcrumb/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 71
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var breadcrumbLess = {};
import genaration from '../../utils/classname';
export var breadcrumbClass = (cov_vvh503vkb.s[0]++, genaration(breadcrumbLess, 'breadcrumb'));